export enum PatientInfoGroups {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  CONTACT = 'contact'
}
